<div class="dropdown">
  @if (params.data?.isEditable) {
    <app-zs-select #gridSelect [(dataSource)]="dataSource"
      [(selected)]="params.value"
      [customStyle]="{ width: '14.2em', 'font-size': '1em'}"
      (selectedChange)="selectedValueChanged($event)"
      [flippable]="true">
    </app-zs-select>
  }
  @if (!params.data?.isEditable) {
    <div class="zs-margin-1-0-0-0">{{ params.value }}</div>
  }

</div>
